const firebaseConfig = {
    apiKey: "AIzaSyBneQCIesOUXOE3YEKNE5kCUbzx3FFDypI",
    authDomain: "camera-ecommerce.firebaseapp.com",
    projectId: "camera-ecommerce",
    storageBucket: "camera-ecommerce.appspot.com",
    messagingSenderId: "404800713561",
    appId: "1:404800713561:web:c92271c4d22c88b7b15248"
  };
  export default firebaseConfig;